export default __webpack_public_path__ + "static/media/waiting.cc946dd2.png";